import { Box } from '@driftt/dds'
import React from 'react'
import sanitizeHtml from 'sanitize-html'

const sanitizeOptions = {
  allowedTags: ['a'],
  allowedAttributes: { a: ['href'] },
}

export const PromptContainer = ({
  children,
  cssStyles,
}: {
  children?: string
  cssStyles?: React.CSSProperties
}) => {
  const sanitizedContent = children
    ? sanitizeHtml(children, sanitizeOptions)
    : ''

  const containerStyles: React.CSSProperties = {
    paddingLeft: '$2',
    borderLeft: 'solid 2px $gray5',
    width: '100%',
    whiteSpace: 'pre-line',
    ...cssStyles,
  }

  return (
    <Box css={{ paddingLeft: '$2' }}>
      <Box
        dangerouslySetInnerHTML={{ __html: sanitizedContent }}
        css={{ ...containerStyles }}
      />
    </Box>
  )
}
